import { jsx } from 'react/jsx-runtime';
import { Pill } from '../../Pill/Pill.js';

function TreeSelectSelectedPills(_ref) {
  let {
    onDismiss,
    selectedNodes,
    disabled
  } = _ref;
  if (selectedNodes.length === 0) {
    return null;
  }
  return jsx("div", {
    className: "ics-treeselect__pills",
    children: selectedNodes.map(node => {
      var _a;
      const label = (_a = node.label) !== null && _a !== void 0 ? _a : String(node.key);
      return jsx(Pill, {
        className: "ics-treeselect__pill",
        size: "small",
        onDismiss: disabled ? undefined : event => {
          onDismiss(String(node.key), event);
        },
        dismissAriaLabel: !disabled && typeof label === 'string' ? "Remove ".concat(label) : undefined,
        children: jsx("span", {
          className: "ics-treeselect__pill-label",
          children: label
        })
      }, String(node.key));
    })
  });
}

export { TreeSelectSelectedPills };
